// You can write more code here

import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';

/* START OF COMPILED CODE */

export default class IngameLoadingScreen extends Phaser.Scene {
  constructor() {
    super('IngameLoadingScreen');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // loadingScreen
    const loadingScreen = this.add.container(0, 0);

    // uIBlocker
    const uIBlocker = new UIBlocker(this, 0, 0);
    loadingScreen.add(uIBlocker);

    // loadingSpinner
    const loadingSpinner = this.add.image(512, 384, 'loading-spinner_512x512');
    loadingSpinner.scaleX = 0.1;
    loadingSpinner.scaleY = 0.1;
    loadingScreen.add(loadingSpinner);

    this.loadingSpinner = loadingSpinner;

    this.events.emit('scene-awake');
  }

  private loadingSpinner!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  // Write your code here

  preloader() {}

  create(data: any) {
    this.editorCreate();

    const anchor = getAnchorPlugin(this);
    anchor.add(this.loadingSpinner, {
      centerX: '50%',
      centerY: '50%',
    });

    this.tweens
      .add({
        targets: this.loadingSpinner,
        rotation: Math.PI * 2,
        duration: 2000,
        ease: 'Linear',
        repeat: -1,
      })
      .play();

    data.doLoad?.();
  }

  doLoading(doLoad: () => void) {
    doLoad();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
